import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { Button } from "./deletePopUp/style";
import { updateCourse } from "../../services/labServices";

const SaveCoursePopUp = ({ toggle, isOpen, history, course }) => {
  const handleSaveDraft = async () => {
    await updateCourse(course.id, { status: "Draft" });
    history.goBack();
    toast.warning("El curso guardado en Draft permanecera en estado deshabilitado");
    toggle();
  };
  return (
    <div>
      <Modal isOpen={isOpen} centered size="sm">
        <ModalHeader className="border-0 height-50" toggle={toggle} />
        <ModalBody>
          <>
            <FontAwesomeIcon icon={faWarning} className="-100" color="red" size="3x" />
            <div className="p-2 w-100 d-flex flex-column justify-content-center align-items-center">
              <p
                className="d-block badge-pills h-50 w-100 justify-content-center text-center py-2"
                style={{ fontSize: "14px", fontWeight: "normal", fontFamily: "Nunito" }}
              >
                No se puede publicar el curso mientras se encuentren <span style={{ fontWeight: "bold" }}>unidades o segmentación </span>sin completar. Desea guardarlo
                como Draft?
              </p>
            </div>
          </>
        </ModalBody>
        <ModalFooter className="border-0">
          <Button className="btn text-center" onClick={toggle} type="button">
            No
          </Button>
          <Button className="btn text-center" style={{ backgroundColor: "red", color: "white" }} onClick={handleSaveDraft} type="button">
            Si
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SaveCoursePopUp;
